/*
 * @Author: Wei Guojun 
 * @Date: 2021-04-09 15:03:12 
 * @Last Modified by: Wei Guojun
 * @Last Modified time: 2023-03-27 18:03:03
 */

<template>
  <div class="header">
    <header>
      <div class="_header">
        <div class="left">
          <img src="../assets/images/new_logo.png" alt="韵商宝" />
          <span class="banben">v1.7.5 </span>
        </div>
        <div class="leftauto">
            <div class="teamBox" @click="changeRole">
              {{$store.state.teamModel=='2'?'团队':'个人'}}
              <img src="../assets/images/team.png" alt="转换" />
            </div>
        </div>
        <div class="forsign">
          <div>签收统计：{{ signObj.startTime }} - {{ signObj.endTime }}</div>
          <div class="dlBox" @click="gotoSign(1)">
            <img src="@/assets/images/dlan.png" />待揽件<span>
              {{ signObj.waitCollectNum }}</span
            >
          </div>
          <div class="dlBox" @click="gotoSign(4)">
            <img src="@/assets/images/vqian.png" />运输中<span>
              {{ signObj.waitSignNum }}</span
            >
          </div>
          <div class="dlBox" @click="gotoSign(3)">
            <img src="@/assets/images/yqian.png" />已签收<span>
              {{ signObj.signedNum }}</span
            >
          </div>
        </div>
        <div class="right">
          <template v-if="$route.name != 'logistics'">
            <span @click="goto('/setTemplate')">打印机</span>
            <el-tooltip content="Bottom center" placement="bottom" effect="light">
              <div slot="content" class="selfContent">
                <div class="itemView" v-if="$store.state.connetStatus.lodopStatus"><img src="../assets/images/pcnorlmal.png" class="selftootipImg"><span class="colorgreen">打印机插件已安装</span></div>
                <div class="itemView" v-else @click="goerrorTip(printObstruct.noInstall)"><img src="../assets/images/pcerror.png" class="selftootipImg"><span class="colorhs">打印插件未安装</span><i class="el-icon-question questionIcon"></i></div>
                <div class="itemView" v-if="$store.state.connetStatus.WebSocketstatus"><img src="../assets/images/pcnorlmal.png" class="selftootipImg"><span class="colorgreen">websocket通讯正常</span></div>
                <div class="itemView" v-else @click="goerrorTip(printObstruct.noMessage)"><img src="../assets/images/pcerror.png" class="selftootipImg"><span class="colorhs">websocket通讯异常,请刷新浏览器。</span><i class="el-icon-question questionIcon"></i></div>
                <div class="itemView" v-if="$store.state.connetStatus.name"><img src="../assets/images/pcnorlmal.png" class="selftootipImg"><span class="colorgreen">默认打印机设置正常</span></div>
                <div class="itemView" v-else  @click="goerrorTip(printObstruct.noPrinter)"><img src="../assets/images/pcerror.png" class="selftootipImg"><span class="colorhs">默认打印机设置异常</span><i class="el-icon-question questionIcon"></i></div>
              </div>
              <b>
                <img v-if="$store.state.connetStatus.WebSocketstatus&&$store.state.connetStatus.name&&$store.state.connetStatus.lodopStatus" src="../assets/images/pcnorlmal.png" class="selftootipImg" style="margin-left: 10px;" alt=""/>
                <img v-else src="../assets/images/pcerror.png" class="selftootipImg" style="margin-left: 6px;" alt=""/>
                <span v-if="$store.state.connetStatus.WebSocketstatus&&$store.state.connetStatus.name&&$store.state.connetStatus.lodopStatus" class="colorgreen" style="margin-left: 6px;">可用</span>
                <span v-else class="colored" style="margin-left: 6px;">不可用</span>
                <i class="el-icon-question" style="font-size: 16px;margin-left: 6px;"></i>              
              </b>
            </el-tooltip>
          </template>
          <em @click="questionCenter">帮助</em>
          <el-badge :is-dot="$store.state.mailnum == 1"  class="item" >
            <i class="el-icon-message-solid" @click="mailcenter" style="font-size: 16px;margin-left: 6px;"></i>
          </el-badge>
          <el-dropdown @command="handleCommand">
            <p class="el-dropdown-link" style="color:#fff">
                <img :src="avphoto" alt="头像" style="margin-left: 10px;"/><span style="padding-left:10px;font-size:12px">{{name}}</span>
            </p>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">账号信息</el-dropdown-item>
              <el-dropdown-item command="b">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import util from '@/util/util';
import home from "@/api/home";
import team from "@/api/team";
import { mapGetters } from "vuex";

export default {
  name: "",
  data() {
    return {
      name:'',
      avphoto:'',
      signObj: {
        startTime: util.getlimiTime(30),
        endTime: util.getlimiTime(0),
        signedNum: "",
        waitSignNum: "",
        waitCollectNum: "",
        noprint: "",
        printed: "",
        orders: "",
      },
      printObstruct:{
        noInstall:'',
        noMessage:'',
        noPrinter:'',
      },
      // teamModel:1,//$store.state.teamModel,//-个人模式，2-团队模式
      teamModelFlag:false,
    };
  },

  components: {
    //组件声明
  },

  computed: {
    //计算属性
    ...mapGetters(["getTeammodel"]),
  },
  watch: {
      // getTeammodel:{
      //   handler(val) {
      //     this.getSign()
      //   },
      //   immediate:false
      // },
      // $route:{
      //   handler(val) {
      //     this.$store.dispatch("getRole");
      //   },
      //   immediate:false
      // }
    },
  mounted() {
    setTimeout(() => {
      this.name =util.getCookie('nickname');
      this.avphoto = util.getCookie('headimgurl');      
      const Obstruct = util.getJsonValues(this.$store.state.commondict,'printObstruct')
      if(Obstruct) this.printObstruct = JSON.parse(Obstruct)
    }, 1000);
    const unConnet = ["loading", "login"];
    if (util.getCookie("token") && unConnet.indexOf(this.$route.name) == -1) {
      this.getSign();
      // this.$store.dispatch("getRole");
      // this.getRole();
    }
  },

  methods: {
    goerrorTip(item){
      window.open(item)
    },
    questionCenter(){
      window.open(window.location.origin + '/question/pclist')
    },
    //跳转站内信
    mailcenter(){
      window.open(window.location.origin + '/question/ysbmailList')
    },
    handleCommand(command) {
      if (command == 'a') {
        this.goto('/peosonInfo')
      } else {
        this.exitLogin()
      }
    },
    //跳转签收统计
    gotoSign(type) {
      let query = {
        status: type,
        start: util.getlimiTime(30)+ " 00:00:00",
        end: util.getlimiTime(0)+ " 23:59:59",
      };
      this.$store.commit("SET_NAV_INDEX", 3);
      this.$store.commit("SET_ORDER_STATUS", query);
      this.$router.push({ path: "/printed" });
    },
    //获取签收统计数据
    getSign() {
      const queryObj = {
        account_id: util.getCookie("account_id"),
        start_time: util.getlimiTime(30) + " 00:00:00",
        end_time: util.getlimiTime(0) + " 23:59:59",
      };
      home.signStatistics(this, queryObj).then((res) => {
        if (res.success) {
          const {
            signed_num,
            wait_collect_num,
            transport_num,
            wait_collect_no_print_num,
            wait_collect_yes_print_num,
          } = res.data;
          this.signObj = {
            startTime: util.getlimiTime(30),
            endTime: util.getlimiTime(0),
            signedNum: signed_num || 0,
            waitSignNum: transport_num || 0,
            waitCollectNum: wait_collect_num || 0,
            noprint: wait_collect_no_print_num || 0,
            printed: wait_collect_yes_print_num || 0,
          };
        }
      });
    },
    goto(routeUrl){
      this.$store.commit('SET_ROUTE_FROM',routeUrl)
      this.$router.push({path:routeUrl})    
    },
    exitLogin(){
      this.$confirm("请确定是否退出系统返回登录页面？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showClose: false,
        type: "warning"
      })
      .then(() => {
        util.removeCookie('account_id');
        util.removeCookie("token");
        util.removeCookie("websocket_token");
        util.removeCookie("app_key");
        util.removeCookie('nickname');
        util.removeCookie('headimgurl');
        this.$WebSocketClass.close();  
         this.$router.push({
          path: "/login"
        });        
      })
      .catch(() => {});
    },
    changeRole(){
      if(this.teamModelFlag) return;
      this.teamModelFlag = true
      team.postTeamModel(this).then((res) => {
        //  debugger
         if (res.success&&res.data.code==200) {
            this.$alert(res.data.message, "切换成功", {
            confirmButtonText: "我知道了",
            center: true,
            callback: (action) => {
              if (action == "confirm") {
                this.teamModelFlag = false
                this.$store.dispatch("getRole");
                this.$store.dispatch("getthreeNum");
                this.$store.dispatch("getBindType");
                this.getSign()
              }
            },
          });
          // this.$store.commit("SET_COMMON_DICT", JSON.stringify(res.data));
        }else{
          this.$alert(res.data.message+'<i></i>', "切换失败", {
            dangerouslyUseHTMLString: true,
            customClass:'btnCenter',
            confirmButtonText: "我知道了",
            center: true,
            callback: (action) => {
              this.teamModelFlag = false
              // if (action == "confirm") {
                // list.push(e);
                // objList.push(item);
              // }
            },
          });
        }
      });
      
    }
  }
};
</script>
<style lang='stylus' scoped>
  .header {
    position: fixed;
    z-index: 999;
    width: 100%;
    top: 0;
    left: 0;
        
    header {
      background: linear-gradient(81deg, rgba(35, 173, 255, 1) 0%, rgba(46, 162, 252, 1) 47%, rgba(58, 149, 248, 1) 100%);
      width: 100%;

      ._header {
        padding-right: 30px;
        box-sizing: border-box;
        width: 100%;
        margin: 0 auto;
        height: 50px;
        display: flex;
        justify-content: flex-end;
      }

      >div {
        display: flex;
        align-items: center;
        color: #FFFFFF;
        cursor pointer;
        img {
          height:50px;
          vertical-align: text-top;
        }
      }

      .left {
        font-size: 20px;
        padding-left: 10px;
        float: left;
        position: relative;
        margin-right: 30px;
        .banben{
          position: absolute;
          right: 8px;
          font-size: 12px;
          top: 18px;
        }
      }
      .leftauto{
        flex: 1
      }
      .teamBox{
        font-size: 13px;
        width: 75px;
        height: 29px;
        line-height:27px;
        margin-left: -25px;
        text-align: center;
        box-sizing: border-box;
        border:1px solid #Fff;
        border-radius:20px;
        background:rgba(255,255,255,.3);
        color:#fff;
        cursor:pointer;
        img{
          width: 16px;
          height: 16px;
          vertical-align: middle;
        }
      }
      .right {
        font-size: 12px;
        line-height: 50px;
        padding-left: 20px;
        em{
          border: 1px solid #fff;
          background-color: rgba(255,255,255,0.1)
          font-style: normal;
          padding: 6px 10px;
          border-radius: 6px;
          margin-left: 10px;
        }
        img {
          border-radius: 100%;
          width 36px
          height 36px;
          vertical-align:middle;
        }
      }
    }
  }
  .selftootipImg{
    width 16px !important
    height 16px !important
    display inline-block !important
    vertical-align: text-top !important
  }
  .colorgreen{
    color #19DA92
  }
  .colored{
    color red
  }
  .colorhs{
    color #409EFF
  }
  .selfContent{
    line-height 30px
  }
  .itemView{
    cursor: pointer
    display flex
    align-items center
    span{
      padding-left 10px
    }
  }
  .forsign{
    display: flex;
    justify-content: center;
    line-height: 24px;
    font-size:12px;
    border: 1px solid #fff;
    background-color: rgba(255,255,255,0.1)
    border-radius: 15px;
    padding: 0 16px
    span{
      font-size: 14px;
      color:rgb(255, 208, 75);
    }
    .dlBox{
      padding-left: 10px
      img{
        width: 16px;
        height: 16px;
        padding-right: 6px;
      } 
      &:hover{
       color: rgb(255, 208, 75);
      }     
    }

}
.questionIcon{
  font-size: 16px;
  margin-left: 6px;
  color: #409EFF;
}
</style>